import InputText from './InputText.vue'
import InputTextarea from './InputTextarea.vue'
import InputNumber from './InputNumber.vue'
import InputEmail from './InputEmail.vue'
import InputPassword from './InputPassword.vue'
import InputDate from './InputDate.vue'
import InputSelect from './InputSelect.vue'
import InputRadio from './InputRadio.vue'
import InputCheckbox from './InputCheckbox.vue'
import InputSwitch from './InputSwitch.vue'
import InputAutocomplete from './InputAutocomplete.vue'
import { ICampoTemplate } from './base/BaseInput'

interface IInputFactory {
  [key: string]: any
}

class InputFactory {
  private static readonly componentMap: IInputFactory = {
    text: InputText,
    textarea: InputTextarea,
    number: InputNumber,
    email: InputEmail,
    password: InputPassword,
    date: InputDate,
    select: InputSelect,
    radio: InputRadio,
    checkbox: InputCheckbox,
    switch: InputSwitch,
    autocomplete: InputAutocomplete,
  }

  /**
   * Cria o componente correto baseado no tipoDoCampo
   * @param campo - Objeto contendo informações do campo
   * @returns Componente Vue apropriado
   */
  static createInput(campo: ICampoTemplate): any {
    const componentType = campo.tipoDoCampo.toLowerCase()
    const component = this.componentMap[componentType]

    if (!component) {
      console.warn(`Tipo de campo desconhecido: ${campo.tipoDoCampo}. Usando InputText como fallback.`)
      return InputText
    }

    return component
  }

  /**
   * Retorna o nome do componente baseado no tipo
   * @param tipoDoCampo - Tipo do campo
   * @returns Nome do componente
   */
  static getComponentName(tipoDoCampo: string): string {
    const componentType = tipoDoCampo.toLowerCase()
    const component = this.componentMap[componentType]
    return component ? component.name : InputText.name
  }

  /**
   * Verifica se um tipo de campo é válido
   * @param tipoDoCampo - Tipo do campo
   * @returns Boolean indicando validade
   */
  static isValidType(tipoDoCampo: string): boolean {
    return !!(this.componentMap[tipoDoCampo.toLowerCase()])
  }

  /**
   * Retorna lista de tipos suportados
   * @returns Array com tipos suportados
   */
  static getSupportedTypes(): string[] {
    return Object.keys(this.componentMap)
  }
}

export default InputFactory
export type { ICampoTemplate }
